import React from "react";
import "./ScoreBar.scss";

const ScoreBar = ({ label, score, color, subLabel, metricType, totalPossible }) => {
  let total = totalPossible;
  let displayValue = score;

  // Helper to format to max 2 decimals
  const format2 = (val) => {
    if (isNaN(val)) return val;
    return Number(val).toFixed(2).replace(/\.00$/, ""); // Removes .00 if whole number
  };

  switch (metricType?.toLowerCase()) {
    case "accuracy":
      total = 100;
      displayValue = `${format2(score)}%`;
      break;

    case "time":
      total = 180;
      displayValue = `${format2(score)} min`;
      break;

    case "tpq(avg)":
      total = 600;
      displayValue = `${format2(score)} sec`;
      break;

    case "score":
    default:
      total = totalPossible;
      displayValue = format2(score);
      break;
  }

  const percentage = (score / total) * 100;

  return (
    <div className="score-bar">
      <p className="score-bar__title">{label}</p>

      <div className="score-bar__container">
        <div
          className="score-bar__fill"
          style={{
            height: `${percentage}%`,
            backgroundColor: color,
          }}
        ></div>
      </div>

      <p className="score-bar__score" style={{ color }}>
        {displayValue}
      </p>

      <p className="score-bar__subtitle">{subLabel}</p>
    </div>
  );
};

export default ScoreBar;
